import { PhoneIcon, PhoneXMarkIcon } from '@heroicons/react/24/solid';

interface IncomingCallDialogProps {
  remoteNumber: string;
  onAnswer: () => void;
  onReject: () => void;
}

export function IncomingCallDialog({
  remoteNumber,
  onAnswer,
  onReject,
}: IncomingCallDialogProps) {
  return (
    <div className="fixed inset-0 z-[100] flex items-start justify-center pt-20">
      <div className="absolute inset-0 bg-black/20 backdrop-blur-sm" />
      <div
        className="relative bg-white dark:bg-zinc-900 rounded-2xl shadow-2xl p-8
                    w-[340px] flex flex-col items-center gap-6 animate-in slide-in-from-top-4"
      >
        {/* Pulse ring */}
        <div className="relative">
          <div className="absolute inset-0 rounded-full bg-emerald-500/20 animate-ping" />
          <div className="relative w-16 h-16 rounded-full bg-emerald-500/10 flex items-center justify-center">
            <PhoneIcon className="w-8 h-8 text-emerald-500 animate-bounce" />
          </div>
        </div>

        <div className="text-center">
          <p className="text-xs font-medium uppercase tracking-wider text-zinc-400 mb-1">
            Příchozí hovor
          </p>
          <p className="text-xl font-semibold text-zinc-900 dark:text-zinc-100">
            {remoteNumber}
          </p>
        </div>

        <div className="flex gap-6">
          <button
            type="button"
            onClick={onReject}
            className="flex items-center justify-center w-14 h-14 rounded-full
                       bg-red-500 hover:bg-red-600 text-white
                       transition-colors shadow-lg shadow-red-500/25"
          >
            <PhoneXMarkIcon className="w-6 h-6" />
          </button>
          <button
            type="button"
            onClick={onAnswer}
            className="flex items-center justify-center w-14 h-14 rounded-full
                       bg-emerald-500 hover:bg-emerald-600 text-white
                       transition-colors shadow-lg shadow-emerald-500/25"
          >
            <PhoneIcon className="w-6 h-6" />
          </button>
        </div>
      </div>
    </div>
  );
}
